import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigurationService, PrivacyConsentService } from '@box-core/services';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CookieToggle, PrivacyConsent } from '@box-types';
import dayjs from 'dayjs';

@Component({
  selector: 'cookies-toggles',
  templateUrl: './cookies-toggles.component.html',
  styleUrls: ['./cookies-toggles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookiesTogglesComponent implements OnInit, OnDestroy {
  @Input() public cookiesToggles: CookieToggle[];
  @Input() public partnersNumber: number;

  @Output() private cookiesConsentClose = new EventEmitter();
  @Output() private cookiesConsentBack = new EventEmitter();

  public mandatoryAccepted = true;
  public performanceAccepted: boolean;
  public adAccepted: boolean;
  public uxAccepted: boolean;
  public boxDpnUrl: string;
  private privacySubscription: Subscription;

  constructor(
    private privacyConsentService: PrivacyConsentService,
    private configService: ConfigurationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.privacySubscription = this.privacyConsentService.privacyConsent$.subscribe((consent) =>
      this.onChangePrivacyConsent(consent)
    );
  }

  ngOnInit(): void {
    this.boxDpnUrl = this.getBoxDpnUrl();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.privacySubscription) this.privacySubscription.unsubscribe();
  }

  public onAcceptAll(): void {
    this.performanceAccepted = true;
    this.adAccepted = true;
    this.uxAccepted = true;
    this.saveConsent();
    this.cookiesConsentClose.emit();
  }

  public onClickBack(): void {
    this.cookiesConsentBack.emit();
  }

  public onSave(): void {
    this.saveConsent();
    this.cookiesConsentClose.emit();
  }

  public onChangeConsent(type: string, { checked }: MatSlideToggleChange): void {
    switch (type) {
      case 'performance':
        this.performanceAccepted = checked;
        return;
      case 'ad':
        this.adAccepted = checked;
        return;
      case 'ux':
        this.uxAccepted = checked;
        return;
    }
  }

  private onChangePrivacyConsent(privacyConsent: PrivacyConsent) {
    this.performanceAccepted = privacyConsent.performance;
    this.adAccepted = privacyConsent.ad;
    this.uxAccepted = privacyConsent.ux;
  }

  private saveConsent(): void {
    this.privacyConsentService.setPrivacyConsent({
      performance: this.performanceAccepted,
      ux: this.uxAccepted,
      ad: this.adAccepted,
      ts: dayjs().valueOf()
    });
    if (!this.uxAccepted) this.privacyConsentService.removeUXData();
  }

  public toggleMoreDescription(index: number): void {
    const toggle = this.cookiesToggles[index];
    if (toggle?.moreActive === undefined) return;
    this.cookiesToggles[index].moreActive = !this.cookiesToggles[index].moreActive;
  }

  private getBoxDpnUrl(): string {
    return this.configService.getConfiguration()?.boxDpn as string;
  }
}
